<template>
    <div class="drop-zone" v-if="items">
        <div
            class="drag-el"
            v-for="(item, index) in items"
            :key="item.id"
            draggable="true"
            @dragenter.prevent
            @dragstart="startDrag($event, item)"
            @drop="onDrop($event, index)"
            @dragover.prevent="onOver($event)"
            @dragleave.prevent="onLeave($event)"
        >
            <i class="fa fa-arrows-alt"></i> &nbsp; {{ item.name }}
        </div>
    </div>
</template>

<script>
import ApiManager from './Api/ApiManagerFood.js'

export default {
    props: {
        slug: {
            required: true,
        },
    },

    data() {
        return {
            items: [],
        }
    },

    methods: {
        async fetchFood() {
            try {
                const params = new URLSearchParams({
                    categories: [this.slug].join(','),
                    select: ['id', 'slug', 'name'],
                    groupBy: [],
                })
                const data = await ApiManager.fetchFood(params)
                this.items = data.data
            } catch (error) {
                this.$toast.error(error.response.data.message)
                //throw error; // Rethrow the error if needed
            }
        },

        async changeFoodOrder(index) {
            try {
                const payload = {
                    items: index,
                }
                const data = await ApiManager.changeFoodOrder(payload)
            } catch (error) {
                this.$toast.error(error.response.data.message)
                //throw error; // Rethrow the error if needed
            }
        },

        startDrag(event, item) {
            event.dataTransfer.dropEffect = 'move'
            event.dataTransfer.effectAllowed = 'move'
            event.dataTransfer.setData('itemId', item.id)
        },

        onOver(event) {
            event.preventDefault()
            this.overIndex = this.getIndex(event)
        },

        onLeave() {
            this.overIndex = -1
        },

        onDrop(event, index) {
            this.onLeave()
            const itemId = event.dataTransfer.getData('itemId')
            const item = this.items.find((item) => item.id == itemId)
            const itemPosition = this.items.findIndex((item) => item.id == itemId)
            this.items.splice(itemPosition, 1)
            this.items.splice(index, 0, item)

            console.log('index', index)
            console.log('item', item)

            const idIndexArray = this.items.map((item, index) => ({ id: item.id, index: index + 1 }))
            console.log(idIndexArray)

            this.changeFoodOrder(idIndexArray)
        },

        getIndex(event) {
            //
        },
    },

    async mounted() {
        await this.fetchFood()
    },
}
</script>

<style scoped lang="scss">
.drop-zone {
    max-width: 600px;
    margin: 0 auto;
    // background-color: var(--c-bg-card, #cccccc63);
    color: var(--c-text, #ffffffde);
    padding: 30px;
    border-radius: 8px;
    transition: background-color 0.3s ease;

    @media (max-width: 768px) {
        padding: 15px;
    }
}

.drag-el {
    padding: 12px 25px;
    border: 1px solid var(--c-border, #021832);
    border-radius: 8px;
    background-color: var(--c-bg-card, #021832);
    transition: background-color 0.3s ease;
    cursor: grab;

    &:not(:last-child) {
        margin-bottom: 10px;
    }
}

.on-over {
    border-color: #33a06f;
}
</style>
